import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { makeStyles } from '@material-ui/core';
import 'react-toastify/dist/ReactToastify.css';
import { useDispatch, useSelector } from 'react-redux';
import Results from './Results.js';
import ToolBar from './ToolBar.js';
import { PAGE_SIZE_LIST } from 'src/app/constant/config';
import { _convertObjectToQuery } from 'src/app/utils/apiService.js';
import { useQuery } from 'src/app/hooks/useQuery.js';
import { getListActionLogs } from 'src/features/customerSlice.js';

const ActionLogsScreen = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [params, setParams] = useState({
    page: 1,
    page_size: PAGE_SIZE_LIST
  });
  const query = useQuery();
  const page = query.get('page') || 1;

  useEffect(() => {
    const queryValue = {
      ...params,
      page: page ? page : undefined,
    };
    setParams(queryValue);
  }, [query]);

  useEffect(() => {
    dispatch(getListActionLogs(params));
  }, []);

  const listActionLogs = useSelector(state => state.customerSlice.listActionLogs) 
  const classes = useStyles();

  const getListActionLogsWithParams = data => {
    navigate('/app/manage/action-logs?' + _convertObjectToQuery(data));
    dispatch(getListActionLogs(data));
  };

  return (
    <>
      <div className={classes.root}>
        <div style={{ width: '98%', margin: '0 auto' }}>
          <ToolBar
            searchRef={getListActionLogsWithParams}
          />
          <Results
            className="mt-3"
            listActionLogs={listActionLogs}
            getListActionLogsRef={getListActionLogsWithParams}
          />
        </div>
      </div>
    </>
  );
};

const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    display: 'flex',
    width: '100%',
    paddingTop: theme.spacing(2)
  }
}));

export default ActionLogsScreen;
